import {useMutation} from '@tanstack/react-query';
import {showHttpErrorToast} from '../../utils/http/show-http-error-toast';
import {useAppearanceEditorMode} from '../../admin/appearance/commands/use-appearance-editor-mode';
import {message} from '../../i18n/message';

const appearanceMessage = "Can't logout while in appearance editor.";

export function useLogout() {
  const {isAppearanceEditorActive} = useAppearanceEditorMode();
  return useMutation({
    mutationFn: () => (isAppearanceEditorActive ? noopLogout() : logout()),
    onError: err =>
      showHttpErrorToast(
        err,
        isAppearanceEditorActive ? message(appearanceMessage) : undefined,
      ),
  });
}

// SpiritWeb Static (SSO stage 2 PART 3): a top-level navigation, because the
// server ends the app session and then sends the browser to Authentik.
function logout(): Promise<never> {
  window.location.assign('/sso/logout');
  return new Promise(() => {});
}

function noopLogout() {
  return Promise.reject(appearanceMessage);
}
